/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_And_NextInputs */

const th_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สดและรายการถัดไป`)
};

const en_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live & next up`)
};

const ja_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合中・次の試合`)
};

const zh_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在进行与接下来`)
};

const es_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En directo y a continuación`)
};

const pt_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo e a seguir`)
};

const id_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung dan berikutnya`)
};

const fr_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct et à suivre`)
};

const tl_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live at susunod`)
};

const vi_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trực tiếp và kế tiếp`)
};

const ko_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간과 다음 경기`)
};

const de_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live und als Nächstes`)
};

const ru_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В прямом эфире и далее`)
};

const tr_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı ve sırada`)
};

const it_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diretta e prossime`)
};

const pl_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo i dalej`)
};

const uk_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У прямому ефірі та далі`)
};

const hi_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव और अगला`)
};

const ar_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشر والتالي`)
};

const ms_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung dan seterusnya`)
};

const bn_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি ও পরবর্তী`)
};

const zh_tw2_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播與接下來`)
};

const zh_hk2_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播與接下來`)
};

const ur_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست اور اگلا`)
};

const fa_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنده و بعدی`)
};

const sw_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moja kwa moja na inayofuata`)
};

const nl_live_and_next = /** @type {(inputs: Live_And_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live en hierna`)
};

/**
* | output |
* | --- |
* | "Live & next up" |
*
* @param {Live_And_NextInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const live_and_next = /** @type {((inputs?: Live_And_NextInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_And_NextInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_live_and_next(inputs)
	if (locale === "ja") return ja_live_and_next(inputs)
	if (locale === "zh") return zh_live_and_next(inputs)
	if (locale === "es") return es_live_and_next(inputs)
	if (locale === "pt") return pt_live_and_next(inputs)
	if (locale === "id") return id_live_and_next(inputs)
	if (locale === "fr") return fr_live_and_next(inputs)
	if (locale === "tl") return tl_live_and_next(inputs)
	if (locale === "vi") return vi_live_and_next(inputs)
	if (locale === "ko") return ko_live_and_next(inputs)
	if (locale === "de") return de_live_and_next(inputs)
	if (locale === "ru") return ru_live_and_next(inputs)
	if (locale === "tr") return tr_live_and_next(inputs)
	if (locale === "it") return it_live_and_next(inputs)
	if (locale === "pl") return pl_live_and_next(inputs)
	if (locale === "uk") return uk_live_and_next(inputs)
	if (locale === "hi") return hi_live_and_next(inputs)
	if (locale === "ar") return ar_live_and_next(inputs)
	if (locale === "ms") return ms_live_and_next(inputs)
	if (locale === "bn") return bn_live_and_next(inputs)
	if (locale === "zh-TW") return zh_tw2_live_and_next(inputs)
	if (locale === "zh-HK") return zh_hk2_live_and_next(inputs)
	if (locale === "ur") return ur_live_and_next(inputs)
	if (locale === "fa") return fa_live_and_next(inputs)
	if (locale === "sw") return sw_live_and_next(inputs)
	if (locale === "nl") return nl_live_and_next(inputs)
	return en_live_and_next(inputs)
});